module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kind-wrap"
  }, [(_vm.isSale) ? _c('div', {
    staticClass: "sale",
    class: {
      'active': _vm.saleSelected
    },
    on: {
      "click": _vm.goSale
    }
  }, [_vm._v("查看折扣商品")]) : _vm._e(), _vm._v(" "), (_vm.categories && _vm.categories.length) ? _c('div', {
    staticClass: "kind-list"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("分类\n      "), (_vm.categories.length > 9) ? _c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.getMore('cate')
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.hideCate ? '更多' : '收起'))]), _c('div', {
    staticClass: "icon",
    class: {
      'hide': !_vm.hideCate
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ul-list",
    class: {
      'hide-cate': _vm.hideCate
    }
  }, _vm._l((_vm.categories), function(item, index) {
    return _c('div', {
      staticClass: "list",
      class: {
        'cancel-margin': (index + 1) % 3 == 0,
          'active': _vm.selected[item.id]
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(item.id, 'cate', item.name, $event)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.brands && _vm.brands.length) ? _c('div', {
    staticClass: "kind-list"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("品牌\n      "), (_vm.brands.length > 9) ? _c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.getMore('brand')
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.hideBrand ? '更多' : '收起'))]), _c('div', {
    staticClass: "icon",
    class: {
      'hide': !_vm.hideBrand
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ul-list",
    class: {
      'hide-cate': _vm.hideBrand
    }
  }, _vm._l((_vm.brands), function(item, index) {
    return _c('div', {
      staticClass: "list",
      class: {
        'cancel-margin': (index + 1) % 3 == 0,
          'active': _vm.selected[item.id]
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(item.id, 'brand', item.name, $event)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.hots && _vm.hots.length) ? _c('div', {
    staticClass: "kind-list"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ul-list"
  }, _vm._l((_vm.hots), function(item, index) {
    return _c('div', {
      staticClass: "list",
      class: {
        'cancel-margin': (index + 1) % 3 == 0,
          'active': _vm.selected[item.id]
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(item.id, 'hot', item.name, $event)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "kind-footer"
  }, [_c('span', {
    staticClass: "reset",
    class: {
      'active': _vm.isReset
    },
    on: {
      "click": _vm.goReset
    }
  }, [_vm._v("重置筛选项")]), _vm._v(" "), _c('span', {
    staticClass: "select",
    on: {
      "click": _vm.goSelect
    }
  }, [_vm._v("确定")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tit"
  }, [_vm._v("热门标签\n      "), _c('p')])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03a6c9b2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/navbar/components/nav.vue
// module id = 213
// module chunks = 1 2 3 4 5 6 7 8 9 10 12 13 14 16 17 19 21 26 28 29 31 36 37 40 42